<mat-form-field class="varighet">
  <mat-label>{{ "Velg varighet"|translate }}</mat-label>
  <mat-select [formControl]="skjemakontroll().controls.varighet" data-testid="varighet-nedtrekksmeny">
    @for (innslag of varigheter(); track innslag) {
      <mat-option [value]="innslag">
        {{ innslag }}
        @if (innslag == 1) {
          {{ 'dag'|translate }}
        } @else {
          {{ 'dager'|translate }}
        }
      </mat-option>
    }
  </mat-select>
  @if (periodeSluttDato() != null) {
    <mat-hint align="start">{{ 'Spørreundersøkelsen stenger automatisk når fristen går ut midnatt {sluttdato}'|translate: {sluttdato: periodeSluttDato()|plaindate} }}</mat-hint>
  }
</mat-form-field>

@if (antallRespondenter() > 0) {
  <fieldset>
    <mat-slide-toggle [formControl]="skjemakontroll().controls.sendInvitasjon"
                      matTooltip="{{'Dersom valgt sendes e-post til alle respondentene med informasjon at undersøkelsen nå kan besvares' | translate}}'">
      @if (antallRespondenter() == 1) {
        {{ "Send invitasjon til {antall} respondenter" | translate:{antall: antallRespondenter()} }}
      } @else {
        {{ "Send invitasjon til {antall} respondenter" | translate:{antall: antallRespondenter()} }}
      }
    </mat-slide-toggle>

    @if (skjemakontroll().value.sendInvitasjon) {
      <mat-form-field>
        <mat-label>{{ "Melding inkludert i e-post til respondentene"|translate }}</mat-label>
        <riktekst-redigering [skjemakontroll]="skjemakontroll().controls.beskjed"/>
      </mat-form-field>
    }
  </fieldset>
}
